module.exports = __webpack_public_path__ + "img/cybo_logo_blue.5f4da784.svg";